var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-chat-wrap', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-8 my-8 rounded-xl",
          attrs: {
            "fixed": "",
            "right": "",
            "bottom": "",
            "fab": "",
            "elevation": "16",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "large": ""
          }
        }, [_vm._v("mdi-chat-question")])], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }